<template>
  <v-dialog v-model="dialog" max-width="350px">
    <v-card
      style="border-radius:20px;"
      class="py-2 strategio-card-container"
    >
      <v-card-title
        class="py-2 justify-center"
        style="font-size:20px;font-weight:500;"
      >
        Nueva estructura
      </v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        <v-text-field
          v-model="folderName"
          label="Nombre de carpeta"
          hint="Nombre de la nueva carpeta base"
        ></v-text-field>
      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="layout justify-center">
        <v-btn
          small depressed round dark
          class="strategio-dialog-button"
          color="red"
          @click.native="dialog = false"
        >Cancelar</v-btn>
        <v-btn
          small depressed round dark
          class="strategio-dialog-button"
          color="success"
          :loading="isLoadingReplication"
          @click.native="replicateFolder"
        >Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from '../../utils/eventBus'
import structureStorage from '../../storage/structureStorage'

export default {
  data () {
    return {
      dialog: false,
      itemID: 0,
      originalName: '',
      onSuccess: () => {},
      folderName: '',

      isLoadingReplication: false
    }
  },
  created () {
    eventBus.$off('open-replicate-folder-dialog')
    eventBus.$on('open-replicate-folder-dialog', (data) => {
      this.itemID = data.itemID || 0
      this.originalName = data.originalName || ''
      this.onSuccess = data.onSuccess || (() => {})
      this.folderName = ''
      this.isLoadingReplication = false
      this.dialog = true
    })
  },
  methods: {
    replicateFolder () {
      this.isLoadingReplication = true
      structureStorage.replicateFolder({
        data: {
          itemID: this.itemID,
          originalName: this.originalName,
          folderName: this.folderName
        },
        onSuccess: () => {
          eventBus.$emit('open-custom-snack-bar', {message: 'Se ha creado el folder base correctamente', itsOk: true})
          // emit to routes/main-page.vue
          eventBus.$emit('reload-items', {})
          this.dialog = false
          this.onSuccess()
          this.isLoadingReplication = false
        },
        onError: (error) => {
          console.warn('Error replicating folder: ', error)
          eventBus.$emit('open-custom-snack-bar', {message: 'Ocurrió un problema creando el folder base', itsOk: false})
          this.isLoadingReplication = false
        }
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/replicate-folder-dialog.vue